'use strict';

import Vue from 'vue'
const moment = require('moment')

Object.defineProperty(Vue.prototype, 'moment', { value: moment })